import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppErrorBoundary } from "@/components/AppErrorBoundary";
import { initSentry, setSentryUser } from "@/lib/sentry";
import { useAuthStore } from "@/store/authStore";
import "@/i18n";
import "./index.css";
import App from "./App.tsx";

initSentry();
setSentryUser(useAuthStore.getState().user);

createRoot(document.getElementById("root")!).render(
  <AppErrorBoundary>
    <StrictMode>
      <App />
    </StrictMode>
  </AppErrorBoundary>,
);
